import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a16c0011e93da0014838017_1779883940315/taskflowpro/src/app/task-detail/components/TaskDetailContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a16c0011e93da0014838017_1779883940315/taskflowpro/src/components/AppLayout.tsx");
